export const useCheckObjectDepth = (defaultDepth = 1, children) => {
    const checkChildren = (currentDepth, children) => {
        defaultDepth =
            defaultDepth > currentDepth ? defaultDepth : currentDepth;
        if (!(children && children.length)) return currentDepth;
        children.forEach((item) => {
            checkChildren(currentDepth + 1, item.children);
        });
    };

    checkChildren(0, children);
};



// WEBPACK FOOTER //
// ./src/frontend/helpers/hooks/useCheckObjectDepth.js